import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";
import {
  FiHome,
  FiUsers,
  FiCalendar,
  FiSettings,
  FiHelpCircle,
  FiLogOut,
} from "react-icons/fi";
import { FiTruck } from "react-icons/fi";

import "./AdminLayout.css";

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <div className="admin-container">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <h2 className="logo">CWASH</h2>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/dashboard" className="nav-item">
            <FiHome className="nav-icon" />
            <span>Dashboard</span>
          </NavLink>
          <NavLink to="/carwashes" className="nav-item">
            <FiTruck className="nav-icon" />
            <span>Car Washes</span>
          </NavLink>
          <NavLink to="/users" className="nav-item">
            <FiUsers className="nav-icon" />
            <span>Users</span>
          </NavLink>
          <NavLink to="/checkins" className="nav-item">
            <FiCalendar className="nav-icon" />
            <span>Check-Ins</span>
          </NavLink>
          <NavLink to="/support" className="nav-item">
            <FiHelpCircle className="nav-icon" />
            <span>Support</span>
          </NavLink>
          <NavLink to="/settings" className="nav-item">
            <FiSettings className="nav-icon" />
            <span>Settings</span>
          </NavLink>
        </nav>
        <button className="logout-btn" onClick={handleLogout}>
          <FiLogOut className="nav-icon" />
          <span>Logout</span>
        </button>
      </aside>
      <main className="admin-content">
        <div className="content-header">
          <h3>Welcome back, Admin</h3>
        </div>
        <div className="content-body">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
